const AUTH_ROUTE_NAMES = [
  'connexion',
  'connexion-provider',
  'inscription',
  'nouveau-mot-de-passe',
]

const baseRouteName = route =>
  route && route.name ? route.name.split('___')[0] : null

export default function ({ route, from, $auth }) {
  if (!$auth || !$auth.$storage) {
    return
  }

  const storedRedirect = $auth.$storage.getUniversal('redirect')

  if (AUTH_ROUTE_NAMES.includes(baseRouteName(route))) {
    if (
      process.client &&
      !storedRedirect &&
      from &&
      from.name &&
      !AUTH_ROUTE_NAMES.includes(baseRouteName(from)) &&
      from.fullPath !== route.fullPath
    ) {
      $auth.$storage.setUniversal('redirect', from.fullPath)
    }
    return
  }

  if (storedRedirect) {
    $auth.$storage.removeUniversal('redirect')
  }
}
